"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    fontFamilyPrimary: 'Inter, sans-serif',
    fontFamilySecondary: '"Open Sans", sans-serif',
    fontSize4xs: '0.75rem',
    fontSize3xs: '0.875rem',
    fontSize2xs: '1rem',
    fontSizeXs: '1.125rem',
    fontSizeSm: '1.25rem',
    fontSizeMd: '1.5rem',
    fontSizeLg: '1.75rem',
    fontSizeXl: '2rem',
    fontSize2xl: '2.25rem',
    fontSize3xl: '2.625rem',
    fontSize4xl: '3rem',
    fontSize5xl: '3.375rem',
    fontWeightThin: 100,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightSemiBold: 600,
    fontWeightBold: 700,
    fontWeightBlack: 900,
    lineHeightXs: '1rem',
    lineHeightSm: '1.5rem',
    lineHeightMd: '2rem',
    lineHeightLg: '2.5rem',
    lineHeightXl: '3rem',
    lineHeight2xl: '3.5rem',
    lineHeight3xl: '4.5rem',
};
exports.default = typography;
